import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { BLOQUEOSPERIODOS_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function BloqueosPeriodosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${BLOQUEOSPERIODOS_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
